import { Notifier, Option, panic, UUID } from "@opendaw/lib-std";
import { Pointers } from "@opendaw/studio-enums";
import { TrackBox } from "@opendaw/studio-boxes";
import { IndexedBoxAdapterCollection } from "../IndexedBoxAdapterCollection";
import { TrackBoxAdapter } from "../timeline/TrackBoxAdapter";
export class AudioUnitTracks {
    #adapter;
    #regionNotifier = new Notifier();
    #collection;
    #subscriptions;
    #subscription;
    constructor(adapter, boxAdapters) {
        this.#adapter = adapter;
        this.#collection = IndexedBoxAdapterCollection.create(adapter.box.tracks, box => boxAdapters.adapterFor(box, TrackBoxAdapter), Pointers.TrackCollection);
        this.#subscriptions = UUID.newSet(({ uuid }) => uuid);
        this.#subscription = this.#collection.catchupAndSubscribe({
            onAdd: (adapter) => this.#subscriptions.add({
                uuid: adapter.uuid,
                subscription: adapter.regions.subscribeChanges(() => this.#regionNotifier.notify())
            }),
            onRemove: ({ uuid }) => this.#subscriptions.removeByKey(uuid).subscription.terminate(),
            onReorder: (_adapter) => { }
        });
    }
    create(type, target, index) {
        const graph = this.#adapter.box.graph;
        const tracks = this.#adapter.box.tracks;
        TrackBox.create(graph, UUID.generate(), box => {
            box.index.setValue(index ?? this.#collection.getMinFreeIndex());
            box.type.setValue(type);
            box.tracks.refer(tracks);
            box.target.refer(target);
        });
    }
    controls(target) {
        return Option.wrap(this.#collection.adapters()
            .find(adapter => adapter.target.targetVertex.contains(target), false));
    }
    delete(adapter) {
        const adapters = this.#collection.adapters();
        const deleteIndex = adapters.indexOf(adapter);
        if (deleteIndex === -1) {
            return panic(`Cannot delete ${adapter}. Does not exist.`);
        }
        for (let index = deleteIndex + 1; index < adapters.length; index++) {
            adapters[index].indexField.setValue(index - 1);
        }
        adapter.box.delete();
    }
    get collection() { return this.#collection; }
    values() { return this.#collection.adapters(); }
    catchupAndSubscribe(listener) {
        return this.#collection.catchupAndSubscribe(listener);
    }
    subscribeAnyChange(observer) { return this.#regionNotifier.subscribe(observer); }
    terminate() {
        this.#collection.terminate();
        this.#subscription.terminate();
        this.#subscriptions.forEach(({ subscription }) => subscription.terminate());
        this.#subscriptions.clear();
    }
}
